import { useState } from "react";
import { Collapse, SvgIcon, Typography } from "@mui/material";
import DownArrowIcon from "@static/icons/DownArrow.svg";
import { useStyle } from "./style";

interface IInfosAccordionsProps {
    title: string;
    children: React.ReactNode;
}

export const InfosAccordions = (props: IInfosAccordionsProps) => {
    const { classes } = useStyle();
    const { title, children } = props;
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => setExpanded((prev) => !prev);

    return (
        <div className={classes.root}>
            <button aria-expanded={expanded} className={classes.titleButton} type="button" onClick={handleToggle}>
                <Typography className={classes.titleText} variant="large">
                    {title}
                </Typography>
                <SvgIcon
                    className={`${classes.arrowIconBase} ${expanded ? classes.arrowIconExpanded : classes.arrowIcon}`}
                    component={DownArrowIcon}
                    inheritViewBox
                />
            </button>
            <Collapse in={expanded} timeout={300}>
                <div className={classes.content}>{children}</div>
            </Collapse>
        </div>
    );
};
